import { Layout } from '@/data/types/Layout';

export const getEditCheckoutProfilePage = (): Layout => ({
	name: 'Aside',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		first: [{ name: 'AccountBreadcrumbs', id: 'account-breadcrumbs' }],
		aside: [{ name: 'AccountSidebar', id: 'account-sidebar' }],
		second: [{ name: 'EditCheckoutProfile', id: 'edit-checkout-profile' }],
		footer: [{ name: 'Footer', id: 'footer' }],
	},
});
